module.exports = __webpack_public_path__ + "img/lang-en.4a90ee18.svg";